export const tables = {
    organisations: [{
        name: 'ORGANISATION NAME',
        key: 'name',
        link: '',
    },
    {
        name: 'INSTRUMENT',
        key: 'instrument',
        link: '',
    },
    {
        name: 'SOLD',
        key: 'sold',
        link: '',
    },
    {
        name: 'CREDITS IN USE',
        key: 'credits',
        link: '',
    }],

    admins: [{
        name: 'FULL NAME',
        key: 'full_name',
        type: 'text',
        content: '',
        link: '',
        sort: true,
    },
    {
        name: 'EMAIL',
        key: 'email',
        type: 'text',
        content: '',
        link: '',
        sort: true,
    },
    {
        name: 'PRIMARY ADMIN',
        key: 'user_access__is_primary_admin',
        type: 'button',
        content: 'Make primary admin',
        link: '',
    },
    {
        name: 'BULK DOWNLOAD PERMISSIONS',
        key: 'bulk_download_permission_given',
        type: 'button',
        content: 'Add Bulk Download Permissions',
        link: '',
    },
    {
        name: 'Batches',
        key: 'batch__batch_name',
        type: 'text',
        content: 'Batches',
        link: '',
    },
    {
        name: 'Batch Permission',
        buttonStatus: true,
        key: '',
        type: 'button',
        content: 'Batch Permission',
        link: '',
    },
    {
        name: 'REMOVE',
        key: 'remove',
        type: 'icon',
        content: 'remove',
        link: '',
    },
    // {
    //     name: 'DELETE',
    //     key: 'delete',
    //     type: 'icon',
    //     content: 'delete',
    //     link: '',
    //   }
    


],
    credits: [{
        name: 'INSTRUMENT',
        key: 'organisation_assessment_credit__instrument__instrument_name',
        type: 'text',
        content: '',
        link: '',
        sort: true,
    },
    {
        name: 'TOTAL',
        key: 'total',
        type: 'text',
        content: '',
        link: '',
        sort: true,
    },
    {
        name: 'ALLOTTED',
        key: 'sold_credits',
        type: 'text',
        content: '',
        link: '',
        sort: true,
    },
    {
        name: 'UNALLOTTED',
        key: 'unsold_credits',
        type: 'type',
        content: '',
        link: '',
        sort: true,
    },
        // {
        //     name: 'SELL CREDITS',
        //     key: 'remove',
        //     sort: false,
        //     type: 'icon',
        //     content: 'add'
        // },
        // {
        //     name: 'REVOKE CREDITS',
        //     key: 'remove',
        //     sort: false,
        //     type: 'icon',
        //     content: 'remove'
        // }
    ],

    orgCredits: [{
        name: 'INSTRUMENT',
        key: 'organisation_assessment_credit__instrument__instrument_name',
        type: 'text',
        content: '',
        link: '',
        sort: true,
    },
    {
        name: 'SOLD',
        key: 'total',
        type: 'text',
        content: '',
        link: '',
        sort: true,
    },
    {
        name: 'USED CREDITS',
        key: 'sold_credits',
        type: 'text',
        content: '',
        link: '',
        sort: true,
    }

    ]
}


// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/Details/tableColumns.js